/* eslint-disable func-names */
import { nricFormatRegex } from 'Constants/appointment';
import * as Yup from 'yup';

const requiredMsg = 'This field is required!';
const requiredMsgForGuardian = 'Cannot issue for patient under 16 y/o without a guardian';

const manaDRMCValidationSchema = isNeedValidationAge =>
  Yup.object().shape({
    patientName: Yup.string().trim().required(requiredMsg),
    nricPassportNumber: Yup.string()
      .trim()
      .required(requiredMsg)
      .test('nric', requiredMsgForGuardian, value => {
        if (
          !isNeedValidationAge ||
          !value ||
          !nricFormatRegex.test(value) ||
          value.trim().charAt(0).toUpperCase() !== 'T'
        )
          return true;
        const yearOfBirth = parseInt(value.trim().substring(1, 3), 10);
        const lastTwoNumberOfCurrentYear = new Date().getFullYear() % 100;

        return lastTwoNumberOfCurrentYear - yearOfBirth >= 16;
      }),
    medicalLeaveGrantedType: Yup.string().nullable().required(requiredMsg),
    startDate: Yup.string().nullable().required(requiredMsg),
    numberOfDays: Yup.number().min(1, 'Must be greater than 0').required(requiredMsg),
    // clinic: Yup.string().nullable().required(requiredMsg),
  });

export default manaDRMCValidationSchema;
